/**
 * `/v1/products/{id}/batches` — AI 10 lots, and the field that must never be normalised.
 *
 * **`lot` is stored and matched exactly as given.** Not trimmed of internal whitespace,
 * not upper-cased, not stripped of punctuation. §3.8's scope-typo alarm exists precisely
 * because `Lot 42` and `LOT42` are different lots to a scanner: a recall published
 * against one matches none of the other while the dashboard reports it active. Any
 * normalisation would make the alarm **unable to fire**, because the two spellings would
 * have become one value before anything could notice they differed.
 *
 * `.trim()` is the one concession and it is deliberately the only one — surrounding
 * whitespace is a copy-paste artefact rather than part of a lot code. It is worth stating
 * because it is the thin end of exactly the wedge this file exists to block, and a schema
 * is a more tempting place to add "just a little normalisation" than a route was.
 */
import { z } from "zod";
/** The route's own message, carried across verbatim. */
const LOT_MESSAGE = "lot is required.";
export const createBatchSchema = z
    .object({
    lot: z.string(LOT_MESSAGE).trim().min(1, LOT_MESSAGE),
    /**
     * An expiry date, passed to Postgres as `::date`.
     *
     * **Unvalidated here, on purpose.** The shipped route accepts any string and lets the
     * cast decide, so adding a format rule would refuse values the API currently stores —
     * a wire change wearing the clothes of a tidy-up. `components.md` requires the
     * *display* format to be a fixed `YYYY-MM-DD`; that is a rendering rule, and it is
     * not this schema's to enforce on input.
     */
    expiry: z.string().optional(),
})
    .describe("POST /v1/products/{id}/batches");
//# sourceMappingURL=batches.js.map